import {observer} from "mobx-react";
import {OrganizationPanel} from "../../OrganizationPanel";
import {ServiceTypePanel} from "../../ServiceTypePanel";
import {HolderPanel} from "../../holder/HolderPanel";
import {BankDataPanel} from "../../BankDataPanel";
import {InsurancePanel} from "../../InsurancePanel";
import {DeliveryInfoPanel} from "../../delivery/DeliveryInfoPanel";
import {DocumentPanel} from "../../document/DocumentPanel";
import {VehiclePanelWz} from "./VehiclePanelWz";
import {PreviousRegistrationPanelWz} from "./PreviousRegistrationPanelWz";
import {AffiliatePanel} from "../../AffiliatePanel";

const DetailWz = observer(function DetailWz() {
    return <div className="columns">
        <div className="column is-half">
            <div className="columns">
                <div className="column is-half">
                    <ServiceTypePanel/>
                </div>
                <div className="column is-half">
                    <OrganizationPanel/>
                </div>
            </div>
            <HolderPanel />
            <BankDataPanel />
            <div className="columns">
                <div className="column is-half">
                    <InsurancePanel />
                </div>
                <div className="column is-half">
                    <AffiliatePanel />
                </div>
            </div>
        </div>
        <div className="column is-half">
            <VehiclePanelWz />
            <PreviousRegistrationPanelWz />
            <DeliveryInfoPanel />
            <DocumentPanel />
        </div>
    </div>
})

export {
    DetailWz
}
